import axios from '@/utils/axios'

// ✅ GET ALL
export const getBrands = (params = {}) => {
  return axios.get('/brands', { params })
}

// ✅ GET BY ID
export const getBrandById = (id) => {
  return axios.get(`/brands/${id}`)
}

// ✅ GET BY CODE
export const getBrandByCode = (code) => {
  return axios.get(`/brands/${code}/code`)
}

// ✅ CREATE
export const createBrand = (data) => {
  return axios.post('/brands', data)
}

// ✅ UPDATE
export const updateBrand = (id, data) => {
  return axios.put(`/brands/${id}`, data)
}

// ✅ DELETE
export const deleteBrand = (id) => {
  return axios.delete(`/brands/${id}`)
}